import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgSignOut = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.7499 12.6958L15.7251 19.5767C15.1871 20.1911 13.533 19.761 13.533 18.8804V15.3707H9.37752C8.90055 15.3707 8.51683 14.5102 8.51683 13.9655V10.0335C8.51683 9.48881 8.90055 8.62916 9.37752 8.62916H13.533V5.11862C13.533 4.24213 15.1836 3.80798 15.7251 4.42234L21.7499 11.3032C22.0834 11.6882 22.0834 12.3108 21.7499 12.6958ZM10.9888 19.3714V17.7331C10.9888 17.4628 10.736 17.2416 10.427 17.2416H6.49439C5.66574 17.2416 4.99626 16.6559 4.99626 15.931V8.06709C4.99626 7.34214 5.66574 6.75645 6.49439 6.75645H10.427C10.736 6.75645 10.9888 6.53527 10.9888 6.26495V4.62665C10.9888 4.35632 10.736 4.13515 10.427 4.13515H6.49439C4.01311 4.13515 2 5.89633 2 8.06709V15.931C2 18.1017 4.01311 19.8629 6.49439 19.8629H10.427C10.736 19.8629 10.9888 19.6417 10.9888 19.3714Z", fill: props.fill }));
});
export default SvgSignOut;
